__turbopack_context__.v({
  "footer": "PortalTutorial-module-scss-module__Xb-8lW__footer",
  "highlight": "PortalTutorial-module-scss-module__Xb-8lW__highlight",
  "overlayPanel": "PortalTutorial-module-scss-module__Xb-8lW__overlayPanel",
  "overlayPanels": "PortalTutorial-module-scss-module__Xb-8lW__overlayPanels",
  "pointer": "PortalTutorial-module-scss-module__Xb-8lW__pointer",
  "pointerShape": "PortalTutorial-module-scss-module__Xb-8lW__pointerShape",
  "popover": "PortalTutorial-module-scss-module__Xb-8lW__popover",
  "popoverBody": "PortalTutorial-module-scss-module__Xb-8lW__popoverBody",
  "popoverCard": "PortalTutorial-module-scss-module__Xb-8lW__popoverCard",
  "popoverHeader": "PortalTutorial-module-scss-module__Xb-8lW__popoverHeader",
  "popoverTitle": "PortalTutorial-module-scss-module__Xb-8lW__popoverTitle",
  "progress": "PortalTutorial-module-scss-module__Xb-8lW__progress",
  "root": "PortalTutorial-module-scss-module__Xb-8lW__root",
  "welcome": "PortalTutorial-module-scss-module__Xb-8lW__welcome",
  "welcomeBody": "PortalTutorial-module-scss-module__Xb-8lW__welcomeBody",
  "welcomeCard": "PortalTutorial-module-scss-module__Xb-8lW__welcomeCard",
  "welcomeFooter": "PortalTutorial-module-scss-module__Xb-8lW__welcomeFooter",
  "welcomeHeader": "PortalTutorial-module-scss-module__Xb-8lW__welcomeHeader",
  "welcomeTitle": "PortalTutorial-module-scss-module__Xb-8lW__welcomeTitle",
});
